<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<caass-schoolselector [ShowAll]="true" [ShowAllText]="SchoolSelectShowAllText" [IsReport]="true" [ReportID]="486">
							</caass-schoolselector>
						</div>
					</div>

					<!--Start Date-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.StartDate" name="txtStartDate"></p-calendar>
						</div>
					</div>

					<!--End Date-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.EndDate" name="txtEndDate"></p-calendar>
						</div>
					</div>

					<!--BusID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Bus</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BusID" [(ngModel)]="report.BusID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of BusList" [ngValue]="o.BusID">
									{{ o.BusDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--BusRouteTypeID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Route Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BusRouteTypeID" [(ngModel)]="report.BusRouteTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of BusRouteTypeList" [ngValue]="o.BusRouteTypeID">
									{{ o.BusRouteTypeDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--IncludeClosedDays-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Include Closed Days</label>
						<div class="col-sm-4 col-lg-3">
							<input id="IncludeClosedDays" name="IncludeClosedDays" class="CHK" type="checkbox" [(ngModel)]="IncludeClosedDays" />
						</div>
					</div>

					<!--IncludeAbsent-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Include Absent Students</label>
						<div class="col-sm-4 col-lg-3">
							<input id="IncludeAbsent" name="IncludeAbsent" class="CHK" type="checkbox" [(ngModel)]="IncludeAbsent" />
						</div>
					</div>

					<!--IncludeInSchool-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Include Students In School (Present or Tardy)</label>
						<div class="col-sm-4 col-lg-3">
							<input id="IncludeInSchool" name="IncludeInSchool" class="CHK" type="checkbox" [(ngModel)]="IncludeInSchool" />
						</div>
					</div>

					<!--SortBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortByID" [(ngModel)]="report.SortByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortByList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortDirectionID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Direction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortDirectionID" [(ngModel)]="report.SortDirectionID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortDirectionList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
